import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/psicoterapia";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllPsicoterapiaByTax(params.tratamientoId);
}

export function PsicoterapiaList(props) {
  const [psicoterapiaList, setPsicoterapia] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllPsicoterapiaByTax(props.id)
      .then(setPsicoterapia)
      .catch(console.log);
  }, [props.id]);
  return (
    <>
      {psicoterapiaList?.length ? (
        <ul className='psicoterapia cpt-list'>
          {psicoterapiaList
            .sort((a, b) => {
              // Convertir las fechas a objetos de fecha para comparar
              const dateA = new Date(a.meta.metaFecha);
              const dateB = new Date(b.meta.metaFecha);
              // Ordenar de manera descendente (más reciente primero)
              return dateB - dateA;
            })
            .map((psicoterapia) => (
              <li key={psicoterapia.id}>
                <NavLink
                  to={`${props.id}/seguimiento/psicoterapia/${psicoterapia.id}`}
                >
                  {`Sesión ${psicoterapia.meta.psicNumses}`} -{" "}
                  {`${FormatDate(psicoterapia.meta.metaFecha)}`}
                </NavLink>
              </li>
            ))}
        </ul>

      ) : (
        <></>
      )}
    </>
  );
}

export function PsicoterapiaListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id='content'>
        <h1>Psicoterapia</h1>
      </div>
      <div id='actions'>
        {(props.userRole.includes('administrador') || props.userRole.includes('psicologia')) && (
          <Link className='button is-link' to={`new`}>
            Nuevo
          </Link>
        )}
      </div>
    </>
  );
}
